(() => {
  const parameter = 'filter.p.m.custom.color_family';
  const updatePalette = (source = window.location.href) => {
    const selected = new URL(source, window.location.origin).searchParams.getAll(parameter);
    document.querySelectorAll('.om-color-palette__link').forEach((link) => {
      const family = new URL(link.href, window.location.origin).searchParams.get(parameter);
      if (family && selected.includes(family)) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
  };
  updatePalette();
  window.addEventListener('pageshow', () => updatePalette());
  window.addEventListener('popstate', () => updatePalette());
  document.addEventListener('facet:update', (event) => updatePalette(event.detail.url));
  document.addEventListener('shopify:section:load', () => updatePalette());
})();
